import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import QueryString from 'query-string';
import { ZeroState, ToggleButtonGroup } from 'ecs-react-components/dist/index.es';
import { messages } from './Questionnaires.i18n';
import { loadQuestionnaires, loadHistoricalQuestionnaires }
  from '../../redux/modules/questionnaires/questionnaires-middleware';
import { QuestionnaireCard } from './QuestionnaireCard';
import QuestionnaireCardHistory from './QuestionnaireCardHistory';
import Header from '../../components/Header/Header';
import { setQuestionnaireFilter, questionnaireSelected }
  from '../../redux/modules/questionnaires/questionnaires-action-creator';
import LoadingIndicatorContainer from '../LoadingIndicatorContainer';
import { callWithLoadingIndicator } from '../../redux/modules/loading-indicator/loading-indicator-middleware';
import history from '../../history';

class Questionnaires extends React.Component {
  UNSAFE_componentWillMount() {
    if (this.props.passAssignedQsThrough) {
      return;
    }
    this.props.dispatch(
      callWithLoadingIndicator('Questionnaires', () => this.props.dispatch(loadQuestionnaires(this.props.patientId))))
      .then(
        () => {
          if (this.shouldAutoRedirect()) {
            this.props.dispatch(
              questionnaireSelected(this.props.assignedQuestionnaires[0].assignedQuestionnaireId));
            history.push(this.props.completeQuestionnairePage);
          }
        }
      );
  }

  shouldAutoRedirect = () => {
    const parsedQueryString = QueryString.parse(this.props.location.search);
    return parsedQueryString.isAutoRedirect && this.props.assignedQuestionnaires.length === 1;
  };

  handleClickEvent = (filterValue) => {
    if (!filterValue || filterValue.length === 0) {
      return;
    }
    if (filterValue === 'History') {
      this.props.dispatch(loadHistoricalQuestionnaires(this.props.patientId));
    }
    this.props.dispatch(
      setQuestionnaireFilter(
        filterValue
      ));
  }

  renderCurrentList() {
    if (!this.props.assignedQuestionnaires) {
      return null;
    }
    if (this.props.assignedQuestionnaires.length > 0) {
      return this.props.assignedQuestionnaires.map((questionnaire) => (
        <QuestionnaireCard
          key={questionnaire.assignedQuestionnaireId }
          item={questionnaire}
          language={this.props.language}
          hideDecline={this.props.hideDecline}
          colCssClass={this.props.colCssClass}
        />)
      );
    }
    return (
      <ZeroState
        zeroStateMessage={<FormattedMessage { ...messages.page.zeroState } />}
        stateIconCss="fa-solid fa-list fs-1 mt-5 pt-3 pb-2"
        showZeroHeader={false}
      />
    );
  }

  renderHistoryList() {
    if (this.props.historicalQuestionnaires.length > 0) {
      return this.props.historicalQuestionnaires.map((questionnaire) => (
        <QuestionnaireCardHistory
          key={questionnaire.assignedQuestionnaireId }
          item={questionnaire}
        />)
      );
    }
    return (
      <ZeroState
        zeroStateMessage={<FormattedMessage { ...messages.page.zeroState } />}
        stateIconCss="fa-solid fa-list fs-1 mt-5 pt-3 pb-2"
        showZeroHeader={false}
      />
    );
  }

  render() {
    return (
      <div id="questionnaires-content">
        {
          !this.props.hideHeader ?
            (
              <Header
                headerTitle={<FormattedMessage { ...messages.page.title } /> }
                headerClassName="mb-3"
                badgeNumber={this.props.badgeNumber}
              />
            ) :
            null
        }

        <LoadingIndicatorContainer loadingKey="Questionnaires" >
        {
          !this.props.hideHistory ?
            (
              <div className="row mb-3">
                <ToggleButtonGroup
                  leftLabel={messages.button.current}
                  rightLabel={messages.button.history}
                  handleClickEvent={ this.handleClickEvent }
                  currentSelection={this.props.currentSelection}
                />
              </div>
            ) :
            null
        }
        {
          this.props.currentSelection === 'Current' ?
            this.renderCurrentList() :
            this.renderHistoryList()
        }
        </LoadingIndicatorContainer>
      </div>
    );
  }
}

Questionnaires.propTypes = {
  dispatch: PropTypes.func,
  patientId: PropTypes.string,
  assignedQuestionnaires: PropTypes.array,
  historicalQuestionnaires: PropTypes.array,
  badgeNumber: PropTypes.number,
  currentSelection: PropTypes.string,
  location: PropTypes.object,
  language: PropTypes.string,
  hideHeader: PropTypes.bool,
  hideHistory: PropTypes.bool,
  hideDecline: PropTypes.bool,
  colCssClass: PropTypes.string,
  passAssignedQsThrough: PropTypes.bool,
  completeQuestionnairePage: PropTypes.string,
};

const mapStateToProps = (state, ownProps) => ({
  patientId: state.profile.patient.patientId,
  assignedQuestionnaires: ownProps.assignedQuestionnaires || state.questionnaires.assignedQuestionnaires,
  historicalQuestionnaires: state.questionnaires.historicalQuestionnaires,
  badgeNumber: state.questionnaires.newQuestionnaireCount,
  currentSelection: ownProps.currentSelection || state.questionnaires.filter || messages.button.current.defaultMessage,
  language: state.language.languageCode,
  completeQuestionnairePage: state.questionnaires.completeQuestionnairePage,
});

export default connect(mapStateToProps)(Questionnaires);